import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "72ce2/P1XNOK5P8mlqEKowJ", "GameMonetize", undefined);

//@ts-nocheck
import { _decorator } from "cc";
import { E_ADEventType } from "../../EnumBase";
import { App } from "../../manager/App";
import AdEvent from "../AdEvent";
var ccclass = _decorator.ccclass;

var GameMonetize = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function GameMonetize() {
    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "_isCallPlay", false);

    _defineProperty(this, "isBannering", false);

    _defineProperty(this, "_time_cur", 0);

    _defineProperty(this, "_isAdShow", false);
  }

  var _proto = GameMonetize.prototype;

  _proto.init = function init() {
    var that = this;
    window["SDK_OPTIONS"] = {
      "gameId": "t2fj7u97y93i42nhig1xav7t5tfh3pfx",
      "onEvent": function onEvent(event) {
        console.log("name = ", event.name);

        switch (event.name) {
          case "SDK_GAME_PAUSE":
            that._isAdShow = false;
            console.log("SDK_GAME_PAUSE");
            App.SoundMgr.adState = true; // pause game logic / mute audio

            break;

          case "SDK_GAME_START":
            console.log("SDK_GAME_START");

            if (that._isAdShow) {
              AdEvent.I.handleEvent(E_ADEventType.video_showOver);
            }

            App.SoundMgr.adState = false;
            that._isCallPlay = false; // advertisement done, resume game logic and unmute audio

            break;

          case "SDK_READY":
            // when sdk is ready
            break;

          case "AD_CANCELED":
            console.log("ad_canceled");
            break;

          case "COMPLETE":
          case "SKIPPED":
          case "USER_CLOSE":
            console.log("COMPLETE/SKIPPED");
            that._isAdShow = true;
            break;
        }
      }
    };

    (function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://api.gamemonetize.com/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'gamemonetize-jssdk');
  };

  _proto.playAD = function playAD() {
    if (this._isCallPlay) return;
    this._isCallPlay = true;

    if (typeof window["sdk"] !== 'undefined' && window["sdk"].showBanner !== 'undefined') {
      window["sdk"].showBanner();
    }
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {};

  _proto.showBannerAd = function showBannerAd() {};

  _proto.hideBannerAd = function hideBannerAd() {} // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {};

  _proto.showInterstitialAd = function showInterstitialAd() {
    this.playAD();
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {};

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    this.playAD();
  };

  return GameMonetize;
}(), _temp)) || _class;

export { GameMonetize as default };

_cclegacy._RF.pop();